<fieldset>
  @for (control of controlsArray; track control) {
    @if (control.type === 'input') {
      <ng-container rsResolve [element]="control"></ng-container>
    }
    @if (control.type === 'form-group') {
      <rs-form-group [controls]="control.controls" [group]="group.controls[control.name]">
      </rs-form-group>
    }
  }
</fieldset>